const INSTAGRAM_HOSTS = new Set(["instagram.com", "www.instagram.com"]);

export const getSafeInstagramUrl = (value?: string | null): string | null => {
    const candidate = value?.trim();
    if (!candidate) return null;

    try {
        const url = new URL(candidate);
        if (url.protocol !== "https:" || !INSTAGRAM_HOSTS.has(url.hostname.toLowerCase())) {
            return null;
        }
        return url.toString();
    } catch (_error) {
        return null;
    }
};

export const getInstagramReelEmbedUrl = (
    value?: string | null
): string | null => {
    const safeUrl = getSafeInstagramUrl(value);
    if (!safeUrl) return null;

    const url = new URL(safeUrl);
    const match = url.pathname.match(/^\/reel\/([a-z0-9_-]+)\/?$/i);
    if (!match) return null;

    return `https://www.instagram.com/reel/${match[1]}/embed/`;
};

export const getInstagramProfileUrl = (
    value?: string | null
): string | null => {
    const handle = value?.trim().replace(/^@/, "");
    if (!handle || !/^[a-z0-9._]{1,30}$/i.test(handle)) return null;
    return `https://www.instagram.com/${handle}/`;
};
